import { DeleteOutlined } from '@ant-design/icons';

import HandlerIcon from '@/assets/icons/HandlerIcon';
import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Typo from '@/components/Typography/Typo';
import { usePublic } from '@/contexts/PublicContext';
import { useFeedbackTerminology } from '@/entities/workspace';
import {
  DEFAULT_FEEDBACKS_SETTING,
  FeedbackGalleryView,
  getFeedbackGalleryTitle,
} from '@/features/(dashboard)/feedback-gallery';
import DashboardCardStyles from '@/features/Dashboard/components/styles/DashboardCardStyles';

import useReportCardDrag from '../../hooks/useReportCardDrag';
import useReportStore from '../../store/ReportStore';
import type { ReportColumnProps } from '../ReportEditor/ReportColumn';

const {
  DashboardCardHeader,
  StyledDragArea,
  StyledDashboardCard,
  StyledDashboardCardWrapper,
} = DashboardCardStyles;

const ReportFeedbackGalleryItem = (props: ReportColumnProps) => {
  const { column, width, index } = props;
  const { replaceFeedbackTerminology } = useFeedbackTerminology();

  // 공개 컨텍스트 여부 확인
  const isPublic = usePublic();

  const removeColumn = useReportStore((state) => state.removeColumn);
  const setDragging = useReportStore((state) => state.setDragging);
  const mode = useReportStore((state) => state.mode);

  const isReportEditMode = mode === 'EDIT';

  // feedbacks 설정이 없으면 기본값 사용
  const feedbacksSetting = column.item.feedbacks ?? DEFAULT_FEEDBACKS_SETTING;
  // 쿼리 키 분리를 위해 column alias 사용
  const columnId = column.item.alias;

  const { dragRef, previewRef, isDragging } = useReportCardDrag({
    index,
    setSomeDragging: setDragging,
    column,
  });

  return (
    <StyledDashboardCardWrapper
      ref={previewRef}
      isDragging={isDragging}
      width={width}
      style={{ height: '100%' }}
    >
      <StyledDashboardCard>
        {isReportEditMode && (
          <StyledDragArea ref={dragRef} className="drag-area-handler">
            <HandlerIcon />
          </StyledDragArea>
        )}
        <DashboardCardHeader j="space-between" a="center">
          <Flex g={8} f={1} a="center" padding="0 24px">
            <Typo type="body0" weight="m" multilineEllipsis={2}>
              {getFeedbackGalleryTitle(
                feedbacksSetting.title,
                replaceFeedbackTerminology,
              )}
            </Typo>
          </Flex>
          {isReportEditMode && (
            <Flex a="center" padding="0 24px">
              <IconButton
                outlined={false}
                icon={<DeleteOutlined />}
                sizeType="m"
                onClick={() => removeColumn(column.row_alias, column)}
              />
            </Flex>
          )}
        </DashboardCardHeader>
        <FeedbackGalleryView
          feedbacksSetting={feedbacksSetting}
          columnId={columnId}
          isPublic={isPublic}
          showHeader={false}
        />
      </StyledDashboardCard>
    </StyledDashboardCardWrapper>
  );
};

export default ReportFeedbackGalleryItem;
